import axios from 'axios';
import { useState } from 'react';
import { useForm, SubmitHandler } from 'react-hook-form';
import { useAppSelector } from '../../hooks';
import { appSelectors } from '../../redux/appSlice';

interface FormValues {
  email: string;
}

export const LostPasswordForm = () => {
  const [showForm, setShowForm] = useState<boolean>(true);
  const { register, formState, handleSubmit } = useForm<FormValues>();
  const csrfToken = useAppSelector(appSelectors.csrfToken);

  const onSubmit: SubmitHandler<FormValues> = async (data) => {
    const formResponse = await axios.post(
      `${import.meta.env.VITE_WEBFORM_URL}/submit`,
      {
        webform_id: 'forgotten_password',
        ...data,
      },
      {
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-TOKEN': csrfToken,
        },
      }
    );
    if (formResponse.status === 200) {
      setShowForm(false);
    }
  };

  if (!showForm) {
    return (
      <div className="lost-password-content">
        <p>
          Thank you for requesting a new password. We will be in touch with you
          shortly.
        </p>
      </div>
    );
  }

  return (
    <div className="lost-password-content">
      <div className="lost-password-intro">
        <p>
          Enter your e-mail address and a link you can use to reset your
          password will be sent to you.
        </p>
      </div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="input-wrapper">
          <label>Email address:</label>
          <input
            {...register('email', {
              required: 'Email address is required',
              pattern: {
                value:
                  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                message: 'Please enter a valid email',
              },
            })}
            type="email"
            required
          />
        </div>
        <button type="submit" className="submit-button">Request new password</button>
        {formState.errors.email?.message && (
          <p className="error">{formState.errors.email?.message}</p>
        )}
      </form>
    </div>
  );
};
